import ForecastWeatherMap from "./ForecastWeatherMap";

export default ForecastWeatherMap;